// ローカル実行判定
const IsLocal = (window.location.host.includes("localhost"));
export { IsLocal };
